/**
 * Global Nav
 *
 * @author BarrelNY
 * @since 32.0.0
 */

// const SignupForm = require('../signup-form/signup-form.js')

const API_URL = "/wp-json/api/v1/esp/signup/";


class GlobalNav {
  constructor(el) {
    this.el = el;
    this.searchButton = this.el.querySelector("#search-button");
    this.searchBox = this.el.querySelector("#search");
    this.searchField = this.el.querySelector("#search-form");
    // this.emailField = this.el.querySelector("#global-nav-email");
    // this.emailFormResponse = this.el.querySelector("#global-email-response");
    // const signupFormElement = document.querySelector('#signupForm'); // Use the correct selector
    // if (signupFormElement) {
    //     createSignupForm(signupFormElement);
    // }
    this.menu = this.el.querySelector("#menu");
    this.menuOpenButtons = this.el.querySelectorAll(
      `button[data-action="open-menu"]`
    );
    this.menuCloseButton = this.el.querySelector(
      `button[data-action="close-menu"]`
    );
    this.backdrop = null;

    this.updateNavHeight();
    this.events();
  }

  events() {
    this.searchButton.addEventListener("click", this.toggleSearch.bind(this));
    // this.emailField.addEventListener("submit", this.submitEmail.bind(this));
    for (const button of this.menuOpenButtons) {
      button.addEventListener("click", this.toggleMenu.bind(this));
    }
    this.menuCloseButton.addEventListener("click", this.toggleMenu.bind(this));
    document.addEventListener("keydown", this.handleKeyDown.bind(this));
    window.addEventListener("resize", this.updateNavHeight.bind(this));
  }

  updateNavHeight() {
    const postBreadcrumbs = document.querySelector('.post-breadcrumbs')
		const sponsorBanner = document.querySelector('.post-hero__sponsor-banner')
    
    let navHeight = this.el.offsetHeight - 1

		if (postBreadcrumbs) {
			navHeight += postBreadcrumbs.offsetHeight
		}

		if (sponsorBanner) {
			navHeight += sponsorBanner.offsetHeight
		}

    document.documentElement.style.setProperty(
      "--global-nav-height",
      `${navHeight}px`
    );
  }

  /**
   * Toggle Menu
   */
  toggleMenu(direction = "toggle") {
    if (direction === "close" && this.menu.dataset.open === "false") {
      return;
    }

    if (this.menu.dataset.open === "true") {
      this.menu.dataset.open = false;
      for (const button of this.menuOpenButtons) {
        button.dataset.open = false;
      }
      this.closeBackdrop();
      return;
    }

    this.menu.dataset.open = true;
    for (const button of this.menuOpenButtons) {
      button.dataset.open = true;
    }
    this.openBackdrop();
  }

  /**
   * Toggle Search
   */
  toggleSearch() {
    this.searchBox.classList.toggle("translate-y-[100%]");
    this.searchField.focus();
  }

  /**
   * Open Backdrop
   * @returns {void}
   */
  openBackdrop() {
    if (this.backdrop) {
      this.backdrop.dataset.open = true;
      return;
    }

    const backdrop = document.createElement("div");
    backdrop.className =
      "menu-backdrop bg-black/[.25] fixed w-full h-full top-0 left-0 right-0 bottom-0 z-[3000]";
    backdrop.dataset.open = "false";

    this.menu.parentNode.appendChild(backdrop);
    this.backdrop = backdrop;
    this.backdrop.dataset.open = true;
    this.backdrop.addEventListener("click", this.toggleMenu.bind(this));
  }

  /**
   * Close Backdrop
   * @returns {void}
   */
  closeBackdrop() {
    if (!this.backdrop || this.backdrop.dataset.open === "false") {
      return;
    }

    this.backdrop.dataset.open = false;
    setTimeout(() => {
      this.backdrop.remove();
      this.backdrop = null;
    }, 450);
  }

  handleKeyDown(e) {
    if (e.key === "Escape") {
      this.toggleMenu("close");
    }
  }

  // /**
  //  * Submit Email
  //  *
  //  * @param {event} e
  //  */
  // submitEmail(e) {
  //   e.preventDefault();

  //   const brrl_list_id = this.emailField.dataset.listId;
  //   const email = document.getElementById("global-signup_form").value;

  //   axios
  //     .post(API_URL, {
  //       form_id: "global-nav",
  //       email,
  //       form_data: {
  //         signup_form_id: "global-nav",
  //         signup_list_id: brrl_list_id
  //       }
  //     })
  //     .then(res => {
  //       if (!res.data && !res.data.success) {
  //         this.emailFormResponse.innerText =
  //           "Something went wrong, try again later!";
  //       } else {
  //         this.emailFormResponse.innerText = "Successfully subscribed!";
  //       }
  //     })
  //     .catch(err => {
  //       this.emailFormResponse.innerText =
  //         "Something went wrong, try again later!";
  //     });
  // }
}

export default el => new GlobalNav(el);
